import React, { useEffect, useState } from "react";
import logo from "./logo.svg";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button } from "react-bootstrap";
import CashRegister from "./CashRegister/CashRegister";
import firebaseService from "./services/firebase-service";

interface DeviceData {
  id: number;
  on: boolean;
  tone: number;
  turn: string;
}
function App() {
  const [thePackage, setThePackage] = useState("");
  const [allPackages, setAllPackages] = useState<string[]>([]);

  const [devices, setDevices] = useState<DeviceData[]>([]);

  const addPackageFromCashRegister = (packageName: string) => {
    setAllPackages((prev) => [...prev, packageName]);
  };

  useEffect(() => {
    const hasDevice = (id: number) => {
      for (let i = 0; i < devices.length; i++) {
        const element = devices[i];
        if (element.id == id) {
          return true;
        }
      }
      return false;
    };

    const updateTurn = (id: number, turn: string) => {
      for (let i = 0; i < devices.length; i++) {
        const element = devices[i];
        if (element.id == id) {
          element.turn = turn;
        }
      }
    };

    const updateDeviceStates = (info: DeviceData) => {
      const nextDevices = devices.map((device) => {
        if (device.id === info.id) {
          device.on = info.on;
          device.tone = info.tone;
          device.turn = info.turn;
          // No change
          return device;
        } else {
          // Return a new circle 50px below
          return device;
        }
      });
      // Re-render with the new array
      setDevices(nextDevices);
    };

    firebaseService.regToChangeDeviceAdded((info: DeviceData) => {
      if (!hasDevice(info.id)) devices.push(info);

      firebaseService.regToChangeDeviceTurnChanged((data: string) => {
        updateTurn(info.id, data);      
      }, info.id.toString());
    });
  }, []);
  const renderCashRegisters = () => {
    return (
      <>
        <div className="cashregisters">
          <CashRegister
            addToPackages={addPackageFromCashRegister}
            prefix="A"
            key="A"
          />
          <CashRegister
            addToPackages={addPackageFromCashRegister}
            prefix="B"
            key="B"
          />
          <CashRegister
            addToPackages={addPackageFromCashRegister}
            prefix="C"
            key="C"
          />
        </div>
      </>
    );
  };
  const addPackage = () => {
    setAllPackages((prev) => [...prev, thePackage]);
  };

  const calloutPackage = (e: string) => {
    var array = [...allPackages]; // make a separate copy of the array
    var index = array.indexOf(e);
    if (index !== -1) {
      array.splice(index, 1);
      setAllPackages(array);
      onPackageConfirmed(e);
    }
  };

  const onPackageConfirmed = (theName: string) => {
    firebaseService.updateText(theName);
    for (let i = 0; i < devices.length; i++) {
      const element = devices[i];

      if (element.turn == theName) {
        firebaseService.updateDeviceStatus(true, element.id.toString());
      }
    }
  };
  const renderPackages = () => {
    return (
      <>
        <div className="packages">
          {allPackages.map((msg, index) => (
            <Button
              key={index}
              className="packageButton"
              onClick={() => calloutPackage(msg)}
            >
              {msg}
            </Button>
          ))}
        </div>
      </>
    );
  };

  const renderAddCustomPackage = () => {
    return (
      <>
        <div className="add-package">
          <h1>Agrega pedido</h1>
          <input
            type="text"
            value={thePackage}
            onChange={(event) => {
              setThePackage(event.target.value);
            }}
          />
          <Button onClick={addPackage}>Agregar</Button>
        </div>
      </>
    );
  };
  return (
    <div className="App">
      <header className="App-header">
        <div className="container">
          {renderAddCustomPackage()}
          {renderCashRegisters()}
          {renderPackages()}
        </div>
      </header>
    </div>
  );
}

export default App;
